export function getOpenfieldRegion(awsRegion: string) {
    if (awsRegion.startsWith('eu')) {
        return 'EU';
    }

    if (awsRegion.startsWith('ap')) {
        return 'AU';
    }

    if (awsRegion.startsWith('us')) {
        return 'US';
    }

    if (awsRegion.startsWith('cn')) {
        return 'CN';
    }

    return undefined;
}
